// extracted by mini-css-extract-plugin
export default {"loader":"LoaderButton_loader__+TG+X","loader-container":"LoaderButton_loader-container__8enoo","spin89345":"LoaderButton_spin89345__yj6GY"};